/////////COMMON ACTIONS/////////
export const SAVE_CONFIG = 'SAVE_CONFIG';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';

export const SAVE_CONTACT_LENSES_DATA = 'SAVE_CONTACT_LENSES_DATA';

// ADD TO CART

export const ADD_TO_CART_PENDING = 'ADD_TO_CART_PENDING';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR';

// MY SAVED PRESCRIPTIONS

export const GET_MY_SAVED_PRESCRIPTIONS_PENDING = 'GET_MY_SAVED_PRESCRIPTIONS_PENDING';
export const GET_MY_SAVED_PRESCRIPTIONS_SUCCESS = 'GET_MY_SAVED_PRESCRIPTIONS_SUCCESS';
export const GET_MY_SAVED_PRESCRIPTIONS_ERROR = 'GET_MY_SAVED_PRESCRIPTIONS_ERROR';

export const SET_CURRENT_PRESCRIPTION = 'SET_CURRENT_PRESCRIPTION';
